/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ConnectResponse, MapString } from "./data-contracts";
import { FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "google-authentication";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Initiates OAuth authorization flow to connect an account to Google
   *
   * @name ConnectAnAccountToGoogle
   * @request POST:/v3/tenant/{tenantId}/account/organization/connect
   * @secure
   */
  connectAnAccountToGoogle = (
    tenantId: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/account/organization/connect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectAnAccountToGoogle */
  connectAnAccountToGooglePathGetter = (
    tenantId: string,
    query: {
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/account/organization/connect`, query);

  /**
   * @description Initiates OAuth authorization flow to connect an account to Google
   *
   * @name ConnectAnAccountToGoogle2
   * @request POST:/v3/tenant/{tenantId}/account/individual/connect
   * @originalName connectAnAccountToGoogle
   * @duplicate
   * @secure
   */
  connectAnAccountToGoogle2 = (
    tenantId: string,
    query: {
      /**
       * Is used to verify that auth email == calendar email
       * @pattern [^\s\\/]+
       */
      userId: string;
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/account/individual/connect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectAnAccountToGoogle2 */
  connectAnAccountToGoogle2PathGetter = (
    tenantId: string,
    query: {
      /**
       * Is used to verify that auth email == calendar email
       * @pattern [^\s\\/]+
       */
      userId: string;
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/account/individual/connect`, query);

  /**
   * @description Initiates OAuth authorization flow to connect a secondary account to Google
   *
   * @name ConnectASecondaryAccountToGoogle
   * @request POST:/v3/tenant/{tenantId}/account/secondary/connect
   * @secure
   */
  connectASecondaryAccountToGoogle = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      ConnectResponse,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/account/secondary/connect`,
      method: "POST",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for connectASecondaryAccountToGoogle */
  connectASecondaryAccountToGooglePathGetter = (
    tenantId: string,
    query: {
      /** @pattern [^\s\\/]+ */
      userId: string;
      /** Url where to redirect after completion of the flow */
      redirect: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/account/secondary/connect`, query);
}
